<ds-metadata-field-wrapper [subheading]="subheading" [useGcWeb]="useGcWeb" [label]="label | translate">
    <span *ngFor="let mdValue of mdValues; let last=last;">
        <span [attr.lang]="mdValue.language" [innerHTML]="(mdValue.value | OSPRTruncate : false : 'GC Core Thesaurus::' : 'VDP::') | translate"></span><span *ngIf="!last" [innerHTML]="separator"></span>
    </span>
</ds-metadata-field-wrapper>
